import { Card, Stack, Title } from "@introist/react-foundation/v2";
import ReactMarkdown from "react-markdown";

export const Message = ({ message }: { message: any }) => {
  return <MessageCard message={message} />;
};

function LinkRenderer(props: any) {
  return (
    <a href={props.href} target="_blank" rel="noreferrer">
      {props.children}
    </a>
  );
}

export const MessageCard = ({ message }: { message: any }) => {
  const { type, data } = message;

  return (
    <Card
      key={data.id}
      variant="blended"
      style={{
        border: "none",
        background:
          type === "ai" ? "var(--palette-surface-default)" : "var(--palette-primary-default)",
        padding: "var(--spacing-small) var(--spacing-medium)",
        marginRight: type === "ai" ? "auto" : undefined,
        marginLeft: type === "human" ? "auto" : undefined,
        maxWidth: "80%"
      }}
    >
      <Stack alignItems="center" justifyContent="center">
        {data.additional_kwargs?.type === "markdown" ? (
          <div
            style={{
              fontFamily: "var(--typography-font-text)",
              fontSize: "var(--typography-size-title)"
            }}
          >
            <ReactMarkdown
              components={{
                p: ({ children }) => <>{children}</>,
                a: LinkRenderer
              }}
            >
              {data.content}
            </ReactMarkdown>
          </div>
        ) : (
          <Title
            style={{
              whiteSpace: "pre-line",
              color: type === "human" ? "white" : "black"
            }}
          >
            {data.content}
          </Title>
        )}
      </Stack>
    </Card>
  );
};
